import { Autocomplete, Box, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { t } from 'i18next'

import Can from '../../../Layout/Can/Can'
import { useAuth } from '../../../Shared/Contexts/AuthContext'

const SelectAction = ({ action, onChangeAction, onChangeOrganization }) => {
  const {
    currentUser: { isSuperAdmin, selfOrganizations }
  } = useAuth()

  const handleActionChange = ({ target: { value } }) => onChangeAction(value)

  const handleChangeOrganization = (_, organization) =>
    onChangeOrganization(organization)

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        spacing={2}
      >
        <Grid
          display="flex"
          justifyContent="flex-start"
          size={6}
        >
          <FormControl fullWidth>
            <InputLabel id="action-select-label">
              {t('actions.selectAnAction')}
            </InputLabel>
            <Select
              labelId="action-select-label"
              id="action-select"
              value={action || ''}
              onChange={handleActionChange}
              inputProps={{
                id: 'action-select',
                'aria-labelledby': 'action-select-label action-select'
              }}
            >
              <MenuItem value="downlink">{t('actions.downlink')}</MenuItem>
              <MenuItem value="alarm">{t('actions.alarm')}</MenuItem>
              <MenuItem value="notification">
                {t('actions.notification')}
              </MenuItem>
              <MenuItem value="webhook">{t('actions.webhook')}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid
          display="flex"
          justifyContent="flex-start"
          size={6}
        >
          <Can
            action={'automations_c'}
            expression={() => isSuperAdmin}
          >
            <Autocomplete
              id="select-action-organizations-autocomplete"
              name="organizationKey"
              disableClearable
              fullWidth
              options={selfOrganizations}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option.key === value.key}
              onChange={handleChangeOrganization}
              renderInput={(params) => (
                <TextField
                  name="organizationKey"
                  {...params}
                  label={t('devices.chooseOrganization')}
                  required={true}
                />
              )}
            />
          </Can>
        </Grid>
      </Grid>
    </Box>
  )
}

export default SelectAction
